import { Badge, Button } from "antd";
import React, { useContext, useState } from "react";
import "./style.css";
import notificationIcon from "../../Assets/Icons/Notification.svg";
import NotificationDrawer from "./NotificationDrawer";
import backIcon from "../../Assets/Icons/back.svg";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../App";

const PageLayout = ({ pageName, name, children, arrow }) => {
  const { userData, unreadNotificationCount } = useContext(UserContext)
  const [drawerVisible, setDrawerVisible] = useState(false);
  const navigate = useNavigate();

  const openDrawer = () => setDrawerVisible(true);
  const closeDrawer = () => setDrawerVisible(false);

  return (
    <div className="page-layout">
      <div className="page-header">
        <div className={`${name ? "welcome-styling" : "page-title"}`}>
          {arrow && (
            <img
              src={backIcon}
              alt="arrow"
              style={{ marginRight: "12px", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
          )}
          {pageName} <span className="name">{name}</span>
        </div>

        {userData?.permissions.length > 0 && userData?.permissions.includes("monitoring") &&
          <Badge count={unreadNotificationCount} size="small">
            <Button
              icon={<img src={notificationIcon} alt="notification" />}
              onClick={openDrawer}
            />
          </Badge>
        }
      </div>

      {children}

      <NotificationDrawer visible={drawerVisible} onClose={closeDrawer} />
    </div>
  );
};

export default PageLayout;
